import React from 'react';
import { observer } from 'mobx-react-lite';
import { applicationStore } from '../../store/applicationStore';
import useTranslation from '../../hooks/useTranslation';
import { ConnectionLost } from './connectionLost';
import { CurrencyChangeLoading } from '../../components/currencyChangeLoading';
import './connection.scss';

const ConnectionWr = observer(() => {
  const { isConnectionLost, isChangingCurrency, isSocketConnected, accessToken, isReconnect } =
    applicationStore;
  const t = useTranslation();
  if (!isConnectionLost && !isChangingCurrency && isSocketConnected && !isReconnect) {
    return null;
  }

  return (
    <div className='cpt-no-connection'>
      {isReconnect || (accessToken && (isChangingCurrency || !isSocketConnected)) ? (
        <CurrencyChangeLoading t={t} />
      ) : (
        <ConnectionLost t={t} />
      )}
    </div>
  );
});
export default ConnectionWr;
